//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "EditCard",
  props: ["prorData"],
  components: {},
  data: function data() {
    return {
      show: false,
      loading: false,
      title: "",
      form: {
        cardId: "",
        cardName: "",
        cardCode: "",
        remark: ""
      },
      rules: {
        cardName: [{
          required: true,
          message: "请输入卡片名称",
          trigger: "blur"
        }],
        cardCode: [{
          required: true,
          message: "请输入卡片代码",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(data) {
      var _this = this;

      this.title = "编辑卡片";
      this.show = true;
      this.loading = true; // 清空表单

      this.$nextTick(function () {
        _this.$refs["cardForm"].resetFields();

        _this.loading = false;
        _this.form.cardId = data.card_id;
        _this.form.cardName = data.card_name;
        _this.form.cardCode = data.card_code;
        _this.form.remark = data.remark;
      });
    },
    // 更新卡片
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.cardForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;

          _this2.$http.put(_this2.$base.menhuUrl + "/tabCardInfo/modify", _this2.form).then(function (_ref) {
            var data = _ref.data;

            if (data.resCode == 0) {
              _this2.$message.success(data.resMsg);

              _this2.show = false;

              _this2.$parent.initPage();
            }

            _this2.loading = false;
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    }
  },
  watch: {},
  filters: {}
};